import React from "react";
import "../../App.css";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import "primeicons/primeicons.css";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Paginator } from "primereact/paginator";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import Moment from "moment";
import { addMMPLShortClosedSearchlist } from "../../Actions/MMPLDashboardAPI";
import CountUp from "react-countup";
import Tooltip from "@material-ui/core/Tooltip";

class ShipPOCards extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      first: 0,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  updatePopover(props) {
    return (
      <Popover id="history-tooltip" {...props}>
        <Popover.Content>
          <label>Update</label>
        </Popover.Content>
      </Popover>
    );
  }

  confirmAll = (item) => {
    let data = {
      purchaseOrderId: item.purchaseOrderId,
      isShortClosed: true,
    };
    this.props.dispatch(addMMPLShortClosedSearchlist(data));
  };

  showEditPODetailPanel = (shipId, poId) => {
    const { history, dispatch } = this.props;
    dispatch({ type: "getPOLineItemsSuccess", data: null });
    dispatch({ type: "EditPOView", data: true });
    history.push(`/Home/POViewEdit/${shipId}/${poId}`);
    window.scrollTo(0, 0);
  };

  showEditPOPanel = (shipId, poId) => {
    const { history, dispatch } = this.props;
    dispatch({ type: "getPOLineItemsSuccess", data: null });
    dispatch({ type: "EditPOView", data: true });
    history.push(`/Home/PurchaseOrders/${shipId}/${poId}`);
    window.scrollTo(0, 0);
  };

  showPODetailPanel = (shipId, poId) => {
    const { history, dispatch } = this.props;
    dispatch({ type: "EditPOView", data: false });
    history.push(`/Home/POView/${shipId}/${poId}`);
    window.scrollTo(0, 0);
  };

  render() {
    const { pageSize, totalRecords } = this.props;
    return (
      <div className=" mt-0 mb-4 ml-4 mr-4  cardBck row">
        <div className="col-xl-12 py-3">
          <div className="row px-3">
            {/* <div className="col-lg-12">
                        <div className="p-0">
                            <div className="row">
                                <div className="col-sm-12"> */}
            {this.renderCardPendingData()}
          </div>
        </div>
        {/* </div>
                        </div>
                    </div>
                </div> */}

        {/* {totalRecords !== 0 ? (
                    <Paginator
                        first={this.state.first}
                        rows={pageSize}
                        totalRecords={totalRecords}
                        onPageChange={(e) => this.onPaginatorChange(e)}>
                    </Paginator>
                ) : (
                        <div className="card" style={{ overflow: "hidden", position: "relative" }}>
                            <div class="container">
                                <h6 className="resource-list-title no-item-card">
                                    No Tasks
              </h6>
                            </div>
                        </div>
                    )} */}
      </div>
    );
  }

  onPaginatorChange(event) {
    const { setUpdatedState } = this.props;
    this.setState({ first: event.first });
    setUpdatedState(event.page + 1);
  }

  isGreaterThanDays = (inputDate, days) => {
    if (!inputDate) return false;

    const today = Moment();
    const givenDate = Moment(inputDate);

    const diffDays = today.diff(givenDate, "days");

    return diffDays > days;
  };

  renderCardPendingData = () => {
    const { arraylist, PO } = this.props;
    return arraylist && arraylist.length
      ? arraylist.map((item, index) => {
        return (
          // <div className="full-height pt-3">
          //     <div className="row">
          <>
            {/* <div className="col-lg-1 mt-3" style={{ minWidth: "16%" }}> */}
            {/* <div className="col-lg-2 col-md-3 col-sm-6 col-12 col-xl-2 mt-3">
                            <div className={`card card-selector p-2 text-center h-100`} style={{ marginBottom: 0 }} onClick={() => this.getShipDetails(item.shipId)} >
                                <h1 className={`mb-0 mt-2`} style={{ color: 'rgb(235,125,9)' }}>
                                    <CountUp start={0} end={item.purchaseOrderCount ? item.purchaseOrderCount : 0} duration={2.00} separator="," />
                                    </h1>
                                <h5 className={`text-center`}>{item.shipName ?? ""}</h5>
                                <span>
                                    <span className={`text-center`} style={{ fontWeight: "600" }}>Enrolled On </span><br></br>
                                    <span className="italicFont text-center">
                                        {item.enrolledOn ? Moment(new Date(Date.parse(item.enrolledOn))).format('DD MMM YYYY') : "NA"}
                                    </span>
                                </span>
                            </div>
                        </div> */}
            <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12 p-2 cursor-pointer">
              <div
                className="card ccard px-4 pt-3 pb-3 h-100"
                onClick={() => this.getShipDetails(item.shipId)}
              >
                {/* <div className="bold-count">
                    {" "}
                    <CountUp
                      start={0}
                      end={
                        item.purchaseOrderCount ? item.purchaseOrderCount : 0
                      }
                      duration={2.0}
                      separator=","
                    />
                  </div> */}
                <div className="d-flex pt-1 align-items-center justify-content-between">
                  <div className="bord-title">{item.shipName ?? ""}</div>
                  {(typeof item.isThereIsNo30DaysPo === "boolean"
                    ? item.isThereIsNo30DaysPo
                    : this.isGreaterThanDays(item.lastPulledDate, 30)) && (
                    <Tooltip
                      title={`The POs has not been pulled for the last ${item.daysSinceLastPO ?? 0} days.`}
                      arrow
                      placement="top"
                    >
                      <i
                        className="fa fa-warning-icon fa-exclamation-triangle fa-lg"
                        aria-label={`The POs has not been pulled for the last ${item.daysSinceLastPO ?? 0} days.`}
                      ></i>
                    </Tooltip>
                  )}
                </div>

                <div
                  className="my-3"
                  style={{ border: "0.1px solid #EEEEEE" }}
                ></div>
                <div className="row">
                  <div className="sub-card py-2 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                    Last PO Date
                  </div>
                  <div className="subcard-count py-2 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                    {" "}
                    {item.lastPulledDate
                      ? Moment(
                        new Date(Date.parse(item.lastPulledDate)),
                      ).format("DD MMM YYYY")
                      : "NA"}
                  </div>
                </div>
                <div className="row">
                  <div className="sub-card py-2 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                    Total PO's
                  </div>
                  <div className="subcard-count py-2 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                    {" "}
                    {item.totalPo}
                  </div>
                </div>
                <div className="row">
                  <div className="sub-card py-2 col-xl-8  col-lg-8 col-md-8 col-sm-8 col-8">
                    Exceptions
                  </div>
                  <div className="subcard-count py-2 col-xl-4  col-lg-4 col-md-4 col-sm-4 col-4">
                    {" "}
                    {item.exceptions}
                  </div>
                </div>
                <div className="row">
                  <div className="sub-card py-2 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                    Enrolled On
                  </div>
                  <div className="subcard-count py-2 col-xl-6 col-lg-6 col-md-6 col-sm-6 col-6">
                    {" "}
                    {item.enrolledOn
                      ? Moment(new Date(Date.parse(item.enrolledOn))).format(
                        "DD MMM YYYY",
                      )
                      : "NA"}
                  </div>
                </div>
              </div>
            </div>
          </>

          //     </div>
          // </div>
        );
      })
      : null;
  };

  getShipDetails = (id) => {
    const { history, dispatch } = this.props;
    dispatch({ type: "POSuccess", data: "" });
    history.push(`/Home/Management/POSyncHistory/${id}`);
    window.scrollTo(0, 0);
  };
}

function mapStateToProps(state) {
  return {
    PurchaseOrders: state.MMPLDashboardReducer.PurchaseOrders,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ShipPOCards),
);
